<template>
  <el-dialog
          :title="'详情'"
          :close-on-click-modal="false"
          :visible.sync="visible"
  style="text-align: left">
    <el-form  ref="dataForm"
             label-width="150px">
        <!-- 合同信息 -->
        <el-row>
            <el-form-item :label="'合同信息'">
                <el-col :span="24">
                    <el-table :data="contractList"  border style="width: 100%">
                        <el-table-column label="合同开始时间" prop="startTime" width="100">
                            <template slot-scope="scope">
                                {{scope.row.startTime?scope.row.startTime.substr(0,10):''}}
                            </template>
                        </el-table-column>
                        <el-table-column label="合同结束时间" prop="endTime" width="100">
                            <template slot-scope="scope">
                                {{scope.row.endTime?scope.row.endTime.substr(0,10):''}}
                            </template>
                        </el-table-column>
                        <el-table-column label="服务地点" prop="workPlace" width="100">
                        </el-table-column>
                        <el-table-column label="合同客户" prop="customerName">
                        </el-table-column>
                        <el-table-column label="合同金额(元)" prop="amount" width="100">
                            <template slot-scope="scope">
                                {{toThousands(scope.row.amount)}}
                            </template>
                        </el-table-column>
                        <el-table-column label="合同文本类型" prop="htwblx">
                        </el-table-column>
                        <el-table-column label="备注" prop="remaek">
                        </el-table-column>
                    </el-table>
                </el-col>
            </el-form-item>
        </el-row>

        <!-- 人员配置 -->
        <el-row>
            <el-form-item :label="'人员配置'">
                <el-col :span="24">
                    <el-table :data="workerConfig"  border style="width: 100%">

                        <el-table-column   label="类型" prop="type" width="100">
                        </el-table-column>
                        <el-table-column label="人数" prop="num" width="100">
                        </el-table-column>
                        <el-table-column label="单价(元/人)" prop="price" width="100">
                            <template slot-scope="scope">
                                {{toThousands(scope.row.price)}}
                            </template>
                        </el-table-column>
                        <el-table-column label="开始日期" prop="startDate">
                        </el-table-column>
                        <el-table-column label="截止日期" prop="endDate">
                        </el-table-column>
                    </el-table>
                </el-col>
            </el-form-item>
        </el-row>

        <!-- 已收金额 -->
        <el-row>
            <el-form-item :label="'已收金额'">
                <el-col :span="24">
                    <el-table :data="receiveAmount"  border style="width: 100%">
                        <el-table-column label="期初余额金额(元)" prop="qcyeje">
                            <template slot-scope="scope">
                                {{ scope.row.qcyeje }}
                                <!-- {{toThousands(scope.row.qcyeje)}} -->
                            </template>
                        </el-table-column>
                        <el-table-column label="本期开票金额(元)" prop="bqkpje">
                            <template slot-scope="scope">
                                {{ scope.row.bqkpje }}
                                <!-- {{toThousands(scope.row.bqkpje)}} -->
                            </template>
                        </el-table-column>
                        <el-table-column label="本期收款金额(元)" prop="bqskje">
                            <template slot-scope="scope">
                                {{ scope.row.bqskje }}
                                <!-- {{toThousands(scope.row.bqskje)}} -->
                            </template>
                        </el-table-column>
                        <el-table-column label="期末欠款金额(元)" prop="qmqkje">
                            <template slot-scope="scope">
                                {{ scope.row.qmqkje }}
                                <!-- {{toThousands(scope.row.qmqkje)}} -->
                            </template>
                        </el-table-column>
                        <el-table-column label="收款日期" prop="skrq">
                        </el-table-column>
                    </el-table>
                </el-col>
            </el-form-item>
        </el-row>

        <!-- 其他金额 -->
        <el-row>
            <el-form-item :label="'其他金额'">
                <el-col :span="24">
                    <el-table :data="qtjeData"  border style="width: 100%">
                        <el-table-column label="金额(元)" prop="je">
                            <template slot-scope="scope">
                                {{ scope.row.je }}
                            </template>
                        </el-table-column>
                        <el-table-column label="日期" prop="rq">
                        </el-table-column>
                        <el-table-column label="备注" prop="bz">
                        </el-table-column>
                    </el-table>
                </el-col>
            </el-form-item>
        </el-row>

        <!-- 附件预览 -->
        <el-row :gutter="2" style="height:100%;width:100%">
            <el-col :span="12" style="height:100%;">
                <h3  style="text-align: center;">附件</h3>
                <el-table max-height="250" :show-header="false" :data="fileName" style="width: 100%" >
                    <el-table-column prop="name" show-overflow-tooltip/>
                    <el-table-column  width="150">
                        <template slot-scope="scope">
                            <el-button size="mini" type="primary" @click="preview2(scope.row)">预览</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
            <el-col :span="12" style="height:100%;">
                <h3 style="text-align: center;">补充协议附件</h3>
                <el-table max-height="250" :show-header="false" :data="fileName2" style="width: 100%" >
                    <el-table-column prop="name" show-overflow-tooltip/>
                    <el-table-column  width="150">
                        <template slot-scope="scope">
                            <el-button size="mini" type="primary" @click="preview2(scope.row)">预览</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
        </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import Template from "@/template";
  export default {
      components: {Template},
      data () {

      return {
        visible: false,
        contract: {},
        contractList: [],
        workerConfig:[],
        receiveAmount:[],
        qtjeData:[],
        fileName:[],
        fileName2:[],
        fileData:[],
        fileData2:[]
      }
    },
    methods: {
        init (id) {
            if(!id) return;
            this.contractList = []
            this.visible = true
            this.$nextTick(() => {
                this.contract = id
                this.contractList.push(id)
                this.workerConfig=[]
                this.receiveAmount=[]
                this.qtjeData=[]
                this.$http({
                    url: '/bjba/contract/findConfigByContarctId/'+this.contract.id,
                    method: 'get'
                }).then(({data}) => {
                    console.log(data)
                    this.workerConfig = data.data;
                })
                this.$http({
                    url: '/bjba/contract/findReceiveAmountByContarctId/'+this.contract.id,
                    method: 'get'
                }).then(({data}) => {
                    console.log(data)
                    this.receiveAmount = data.data;
                })
                this.$http({
                    url: '/bjba/contract/findQtjeByContarctId/'+this.contract.id,
                    method: 'get'
                }).then(({data}) => {
                    console.log(data)
                    this.qtjeData = data.data;
                })
                this.$http({
                    url: '/bjba/contract/info/'+this.contract.id,
                    method: 'get'
                }).then(({data}) => {
                    this.fileData  = data.data.attach.htfj
                    this.fileData2  = data.data.attach.htbcfj
                    this.fileReset()
                    this.fileReset2()
                })
            })
        },
        fileReset() {
            this.fileName.splice(0)
            if (this.fileData != undefined && this.fileData.length > 0) {
                this.fileData.forEach((item) => {
                this.fileName.push({
                    id: item.id,
                    saveName: item.saveName,
                    name: item.name
                })
                })
            }
            if (this.fileList != undefined && this.fileList.length > 0) {
                this.fileList.forEach((item) => {
                this.fileName.push(item)
                })
            }
        },
        fileReset2() {
            this.fileName2.splice(0)
            if (this.fileData2 != undefined && this.fileData2.length > 0) {
            this.fileData2.forEach((item) => {
                this.fileName2.push({
                id: item.id,
                saveName: item.saveName,
                name: item.name
                })
            })
            }
            if (this.fileList2 != undefined && this.fileList2.length > 0) {
            this.fileList2.forEach((item) => {
                this.fileName2.push(item)
            })
            }
        },
        preview2(item){
            var viewUrl = this.$request.defaults.baseURL+'/bjba/contract/preview2/'+item.saveName+'?access_token='+this.$store.getters.token
            window.open(viewUrl)
        },
        toThousands(num) {
            var result = [ ], counter = 0;
            num = (num || 0).toString().split('');
            for (var i = num.length - 1; i >= 0; i--) {
                counter++;
                result.unshift(num[i]);
                if (!(counter % 3) && i != 0) { result.unshift(','); }
            }
            return result.join('');
        }
    }
  }
</script>
<style lang="scss" scoped>
    .min-input-class {

        min-height:25px;
        border-bottom:1px dotted  #b0b1b3;
    }
</style>
